function galleryArrowState(scrollLeft, clientWidth, scrollWidth) {
	const maxScroll = scrollWidth - clientWidth

	if (maxScroll <= 1) {
		return { prev: false, next: false }
	}

	return {
		prev: scrollLeft > 1,
		next: scrollLeft < maxScroll - 1,
	}
}

function selectGalleryImage(currentSrc, nextUrl) {
	if (currentSrc === nextUrl) {
		return { src: currentSrc, visible: true }
	}

	return { src: nextUrl, visible: false }
}

function productImages(data) {
	const images = []

	if (data && data.image) {
		images.push(data.image)
	}

	if (data && Array.isArray(data.gallery)) {
		data.gallery.forEach(url => {
			if (url && !images.includes(url)) {
				images.push(url)
			}
		})
	}

	return images
}

module.exports = { productImages, selectGalleryImage, galleryArrowState }
